export enum TokenType {
  USER = 'user',
  AFFILIATE = 'affiliate',
  AFFILIATE_MANAGER = 'affiliate_manager',
}
